import { Dialog } from "primereact/dialog";
import VeiculoService from "../../services/resource/veiculoService";
import { useEffect, useState } from "react";
import Button from "../../componentes/button/button";
import PageAPI from "../../componentes/pagination/Pagination-Page";
import FilterBar from "../../componentes/filtros/filtros";
import { TabelaVeiculo } from "./TabelaVeiculo";
import VeiculoViewModal from "./VeiculoViewModal";
import { toast } from "react-toastify";
import MainCard from "../../componentes/card/MainCard";
import { useAuth } from "../../context/authContext";
import FilialService from "../../services/resource/filialService";
import VeiculoCreate from "./VeiculoCreate";

const initialPage = {
    content: [],
    page: {
        "size": 20,
        "number": 0,
        "totalElements": 0,
        "totalPages": 0
    }
}

const initialSetPage = {
    page: 0,
    size: 20,
    sortKey: "placa",
    sortDirection: "desc"
}

export default function VeiculoMain() {
    const service = new VeiculoService();
    const filialService = new FilialService();
    const { user } = useAuth();

    const schema = [
        {
            key: "filialId",
            label: "Filial",
            disabled: user.perfis.includes('COMISSOES') ,
            component: "Dropdown",
            options: "filiais", // pega data.contaContabil
            mapOption: (item) => ({ label: item.nome, value: item.id }),
            colSpan: 2,
        },
        {
            key: "placa",
            label: "Placa",
            component: "Input",
            colSpan: 1,
        },
        {
            key: "codigoYork",
            label: "Código York",
            component: "Input",
            typeText: 'text',
            colSpan: 1,
        },
        {
            key: "codigoSolar",
            label: "Código Solar",
            component: "Input",
            typeText: 'text',
            colSpan: 1,
        },
        {
            key: "ativo",
            label: "Status",
            component: "Radio",
            options: [
                { label: "Ativos", value: 'true' },
                { label: "Cancelados", value: 'false' },
                { label: "Todos", value: null }
            ],
            colSpan: 2,
            isEmpty: (v) => v === undefined || v === null,
            showClear: true,

        },
    ];

    const initialFilters = {
        filialId: user.filialId,
        placa: '',
        codigoSolar: '',
        codigoYork: '',
        ativo: 'true'
    }

    const [veiculos, setVeiculos] = useState(initialPage);
    const [filiais, setFiliais] = useState([]);
    const [showModal, setShowModal] = useState(false);
    const [veiculoSelecionado, setVeiculoSelecionado] = useState(null);

    const [loading, setLoading] = useState(false);
    const [modalDelete, setModalDelete] = useState(false);
    const [modalEdit, setModalEdit] = useState(false);
    const [page, setPage] = useState(initialSetPage);
    const [selectedFilters, setSelectedFilters] = useState(initialFilters);

    useEffect(() => {
        filialService.listar().then(res => setFiliais(res.data));
    }, []);

    useEffect(() => {
        document.title = "MyDash | Veículos";
        carregarLista();
    }, [page, selectedFilters]);

    function carregarLista() {
        setLoading(true);
        service.listarPaginado(selectedFilters, page)
            .then(res => setVeiculos(res.data))
            .finally(() => setLoading(false));
    }

    const excluir = () => {
        service.desativar(veiculoSelecionado.id)
            .then(() => {
                toast.success("Veículo cancelado com sucesso!");
                carregarLista();
                onCloseModal();
            })
            .catch(e => console.error(e));
    }

    const abrirModal = (veiculo) => {
        setVeiculoSelecionado(veiculo);
        setShowModal(true);
    };

    const abrirModalDelete = (veiculo) => {
        setVeiculoSelecionado(veiculo);
        setModalDelete(true);
    };

    const onCloseModal = () => {
        setVeiculoSelecionado(null);
        setShowModal(false);
        setModalDelete(false);
        setModalEdit(false);
    }

    const onCloseEdit = (veiculoAtualizado) => {
        setVeiculoSelecionado(null);
        setModalEdit(false);

        setVeiculos((prev) => ({
            ...prev,
            content: prev.content.map((item) =>
                item.id === veiculoAtualizado.id ? veiculoAtualizado : item)
        }))

    }

    const abrirModalEdicao = (veiculo) => {
        setVeiculoSelecionado(veiculo);
        setModalEdit(true)
    }

    const header = <Button label="Cadastrar Veículo" iconLeft="fa fa-plus" onClick={() => setModalEdit(true)} />

    return (
        <MainCard
            title="Veículos"
            icon="fa fa-truck"
            header={header}
        >
            <div className="p-6 pt-0 border-b border-border">
                <FilterBar
                    data={{ filiais: filiais }}
                    filters={selectedFilters}
                    onFiltersChange={setSelectedFilters}
                    schema={schema}
                    columns={8}
                    initialFilters={initialFilters}
                />
            </div>

            <TabelaVeiculo
                data={veiculos}
                loading={loading}
                editar={(obj) => abrirModalEdicao(obj)}
                excluir={abrirModalDelete}
                visualizar={abrirModal}
                setPage={setPage}
            />

            <PageAPI
                page={veiculos.number || 0}
                size={veiculos.size}
                totalElements={veiculos.totalElements}
                totalPages={veiculos.totalPages}
                loading={loading}
                onPageChange={(newPage) =>
                    setPage(prev => ({ ...prev, page: newPage }))
                }
                onPageSizeChange={(newSize) =>
                    setPage(prev => ({ ...prev, size: newSize }))
                }
            />

            <VeiculoViewModal
                visible={showModal}
                onHide={() => setShowModal(false)}
                veiculo={veiculoSelecionado}
            />

            <Dialog
                header={veiculoSelecionado ? "Editar Veículo " + veiculoSelecionado?.placa : "Cadastrar Veículo"}
                visible={modalEdit}
                onHide={onCloseModal}
                blockScroll
                className="w-[95%]"
                contentClassName="p-0"
            >
                <VeiculoCreate id={veiculoSelecionado?.id} onClose={onCloseModal} onCloseEdit={onCloseEdit} />
            </Dialog>

            <Dialog
                header={veiculoSelecionado?.ativo ? "Cancelamento de Veículo" : "Reativação de Veículo"}
                visible={modalDelete}
                onHide={onCloseModal}
                blockScroll
                footer={
                    <div className="flex pt-3 justify-end gap-2">
                        <Button
                            onClick={onCloseModal}
                            label="Voltar"
                            variant="gray"
                            iconLeft={"fa fa-arrow-left"}

                        />
                        <Button
                            type="submit"
                            label={veiculoSelecionado?.ativo ? "Cancelar" : "Reativar"}
                            iconLeft={"fa fa-check"}
                            onClick={excluir}
                        />
                    </div>
                }
            >
                <div className="text-md pt-4">
                    {veiculoSelecionado?.ativo ?
                        'Você confirma o cancelamento do veículo selecionado?'
                        :
                        'Você confirma a reativação do veículo selecionado?'
                    }
                </div>
            </Dialog>

        </MainCard>
    );
}
